// 多色 baby 動畫自動對應
const babyVideoMap = {
  fire:   "redbaby.mp4",
  water:  "bluebaby.mp4",
  brown:  "brownbaby.mp4",
  gold:   "goldbaby.mp4",
  green:  "greenbaby.mp4",
  orange: "orangebaby.mp4"
};

export function PetMediaBox({ pet }) {
  if (!pet || !pet.photoUrl) return <div className="pet-image-placeholder" />;

  // 動畫寶寶判斷
  if (pet.stage === "baby" && babyVideoMap[pet.element]) {
    // 路徑全部小寫，確保主機相容
    const src = `/images/Pet/baby/animation/${babyVideoMap[pet.element]}`;
    return (
      <div className="pet-img-box">
        <video
          src={src}
          autoPlay
          loop
          muted
          playsInline
          // 不要再加 width/height，css 會自動處理
        />
      </div>
    );
  }

  // 其它直接判斷是否是 mp4 檔案
  if (pet.photoUrl.match(/\.mp4$/i)) {
    return (
      <div className="pet-img-box">
        <video
          src={pet.photoUrl}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
    );
  }

  // fallback: 一般圖片
  return (
    <div className="pet-img-box">
      <img src={pet.photoUrl} alt="Pet" />
    </div>
  );
}

// .\ffmpeg.exe -i "D:\GitHub Repository\KoalaQuest\public\images\Pet\baby\animation\bluebaby.MP4" -vcodec libx264 -acodec aac -pix_fmt yuv420p "D:\GitHub Repository\KoalaQuest\public\images\Pet\baby\animation\bluebaby-h264.mp4" 